module.exports = __webpack_public_path__ + "img/otp-icon.b744eef5.png";